module.exports = {"_devnotes":"Claves de google analytics por dominio https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/692092941/Google+Analytics#GoogleAnalytics-ClavesUtilizadas","default":"UA-120004517-1","localhost":"UA-120004517-1","dev.b2b.olympiaviajes.es":"UA-120004517-1","qa.b2b.olympiaviajes.es":"UA-120004517-1","bedbankeroski.viajesolympia.com":"UA-119880521-1","bedbank.viajesolympia.com":"UA-119880521-2","b2b.olympiaviajes.es":"UA-119880521-2","bedbank.dawsontravel.ie":"UA-119880521-3"}


//////////////////
// WEBPACK FOOTER
// ./src/GAHostToKeys.json
// module id = 3457
// module chunks = 0